import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignIn } from "@fortawesome/free-solid-svg-icons";
import Dashboard from "./Dashboard"; // eslint-disable-line import/no-named-as-default

const HomePage = ({ auth }) => {
  if (auth.isAuthenticated()) {
    return <Dashboard auth={auth} />;
  }

  return (
    <div className="d-flex align-items-center justify-content-center" style={{ minHeight: "70vh" }}>
      <div className="text-center">
        <h1>Engineers Hub</h1>
        <p className="text-muted mb-4">Please sign in to continue</p>
        <button className="btn btn-danger btn-lg" onClick={auth.login}>
          <FontAwesomeIcon icon={faSignIn} className="me-2" />
          Sign In
        </button>
      </div>
    </div>
  );
};

HomePage.propTypes = {
  auth: PropTypes.object.isRequired,
};

export default HomePage;
